export default __webpack_public_path__ + "static/media/profile.a6cd8b73.jpg";